export const ADB_RATES = {
  RP: [
    0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6,
    0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6,
    0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6,
  ],
  SP: [
    2.25, 2.59, 2.9, 3.19, 3.47, 3.73, 3.97, 4.2, 4.41, 4.61, 4.8, 4.97, 5.14, 5.29, 5.44, 5.57, 5.7, 5.82, 5.93, 6.04,
    6.14, 6.23, 6.32, 6.4, 6.47, 6.54, 6.61, 6.67, 6.73, 6.78, 6.83, 6.88, 6.92, 6.97, 7.0, 7.04, 7.07, 7.1, 7.13, 7.16,
    7.18, 7.2, 7.22, 7.23, 7.24, 7.25, 7.26, 7.28, 7.29, 7.3, 7.32, 7.32982, 7.34282, 7.35582, 7.36882, 7.38182,
    7.39482, 7.40782, 7.42082, 7.43382, 7.44682, 7.45982, 7.47282,
  ],
  LP5: [
    0.6, 0.668, 0.736, 0.804, 0.872, 0.94, 1.06, 1.19, 1.31, 1.44, 1.56, 1.68, 1.79, 1.9, 2.01, 2.13, 2.16, 2.2, 2.24,
    2.28, 2.31, 2.34, 2.36, 2.39, 2.41, 2.44, 2.45, 2.46, 2.48, 2.49, 2.5, 2.53, 2.55, 2.58, 2.6, 2.63, 2.64, 2.65,
    2.66, 2.68, 2.69, 2.7, 2.71, 2.73, 2.74, 2.75, 2.76, 2.78, 2.79, 2.8, 2.81, 2.83, 2.84, 2.85, 2.86, 2.88, 2.88,
    2.88, 2.90988, 2.91772, 2.92534, 2.93274, 2.93994,
  ],
  LP7: [
    0.0, 0.0, 0.6, 0.65334, 0.70667, 0.76, 0.8, 0.85, 0.99, 1.07, 1.14, 1.22, 1.3, 1.38, 1.45, 1.53, 1.56, 1.58, 1.61,
    1.63, 1.66, 1.68, 1.7, 1.71, 1.73, 1.75, 1.77, 1.79, 1.8, 1.82, 1.84, 1.85, 1.87, 1.88, 1.89, 1.91, 1.92, 1.93,
    1.94, 1.96, 1.97, 1.97, 1.98, 1.98, 1.99, 1.99, 2.0, 2.01, 2.02, 2.02, 2.03, 2.04, 2.05, 2.05, 2.06, 2.07, 2.08,
    2.1, 2.11561, 2.12165, 2.12753, 2.13325, 2.13881,
  ],
  LP10: [
    0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.642, 0.684, 0.726, 0.768, 0.81, 0.87, 0.92, 0.98, 1.04, 1.09, 1.12, 1.15, 1.18,
    1.21, 1.24, 1.25, 1.26, 1.27, 1.29, 1.3, 1.31, 1.33, 1.34, 1.35, 1.37, 1.38, 1.39, 1.4, 1.42, 1.43, 1.44, 1.46,
    1.47, 1.48, 1.5, 1.51, 1.52, 1.53, 1.55, 1.56, 1.57, 1.58, 1.58, 1.59, 1.6, 1.6, 1.61, 1.61, 1.62, 1.63, 1.63, 1.63,
    1.63807, 1.64356, 1.64891, 1.65412, 1.65919,
  ],
  LP15: [
    0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.62457, 0.65757, 0.69203, 0.72823, 0.7656, 0.80256, 0.83835,
    0.87275, 0.90575, 0.93747, 0.96679, 0.99385, 1.01885, 1.04261, 1.0647, 1.08531, 1.10516, 1.12381, 1.14138, 1.15853,
    1.17478, 1.19025, 1.20499, 1.21958, 1.23356, 1.24699, 1.26038, 1.27329, 1.28576, 1.29825, 1.31036, 1.32211, 1.33353,
    1.34504, 1.35625, 1.36718, 1.37785, 1.38793, 1.3978, 1.40748, 1.41664, 1.42566, 1.43421, 1.44264, 1.45097, 1.45889,
    1.46642, 1.47384, 1.48106, 1.48811, 1.49498, 1.50168,
  ],

  WLLP60: {
    5: [
      0.6, 0.668, 0.736, 0.804, 0.872, 0.94, 1.06, 1.19, 1.31, 1.44, 1.56, 1.68, 1.79, 1.9, 2.01, 2.13, 2.16, 2.2, 2.24,
      2.28, 2.31, 2.34, 2.36, 2.39, 2.41, 2.44, 2.45, 2.46, 2.48, 2.49, 2.5, 2.53, 2.55, 2.58, 2.6, 2.63, 2.64, 2.65,
      2.66, 2.68, 2.69, 2.7, 2.71, 2.73, 2.74, 2.75, 2.76, 2.78, 2.79, 2.8, 2.81, 2.83, 2.84, 2.85, 2.86, 2.88, 2.88,
      2.88, 2.90988, 2.91772, 2.92534, 2.93274, 2.93994,
    ],
    6: [
      0.0, 0.6, 0.66073, 0.72028, 0.77878, 0.83633, 0.90689, 0.98794, 1.07324, 1.16303, 1.25373, 1.34479, 1.4343,
      1.52243, 1.60937, 1.69652, 1.77283, 1.84157, 1.90416, 1.96171, 2.01411, 2.06222, 2.10585, 2.14654, 2.18392,
      2.21924, 2.25132, 2.2806, 2.30812, 2.33347, 2.3569, 2.37986, 2.40181, 2.42344, 2.44424, 2.46481, 2.48418, 2.50246,
      2.51977, 2.53665, 2.55271, 2.56801, 2.58263, 2.59704, 2.61086, 2.62414, 2.63692, 2.64961, 2.66187, 2.67372,
      2.6852, 2.69667, 2.7078, 2.71862, 2.72916, 2.73973, 2.74974, 2.75921, 2.76906, 2.77863, 2.78794, 2.79699, 2.8058,
    ],
    7: [
      0.0, 0.0, 0.6, 0.65334, 0.70667, 0.76, 0.8, 0.85, 0.99, 1.07, 1.14, 1.22, 1.3, 1.38, 1.45, 1.53, 1.56, 1.58, 1.61,
      1.63, 1.66, 1.68, 1.7, 1.71, 1.73, 1.75, 1.77, 1.79, 1.8, 1.82, 1.84, 1.85, 1.87, 1.88, 1.89, 1.91, 1.92, 1.93,
      1.94, 1.96, 1.97, 1.97, 1.98, 1.98, 1.99, 1.99, 2.0, 2.01, 2.02, 2.02, 2.03, 2.04, 2.05, 2.05, 2.06, 2.07, 2.08,
      2.1, 2.11561, 2.12165, 2.12753, 2.13325, 2.13881,
    ],
    8: [
      0.0, 0.0, 0.0, 0.6, 0.64902, 0.69726, 0.74032, 0.78298, 0.85105, 0.91951, 0.98532, 1.0512, 1.1169, 1.18228,
      1.24555, 1.30873, 1.36423, 1.41232, 1.45591, 1.49465, 1.53067, 1.56336, 1.5933, 1.61997, 1.64487, 1.66828,
      1.69043, 1.71152, 1.73088, 1.74954, 1.76758, 1.78439, 1.80079, 1.81618, 1.83068, 1.84502, 1.85861, 1.87154,
      1.88387, 1.89622, 1.90806, 1.91893, 1.92942, 1.93908, 1.94846, 1.95713, 1.9656, 1.97389, 1.98201, 1.98956, 1.997,
      2.00433, 2.01157, 2.01834, 2.02505, 2.0317, 2.0383, 2.04519, 2.05221, 2.05904, 2.06568, 2.07214, 2.07842,
    ],
    9: [
      0.0, 0.0, 0.0, 0.0, 0.6, 0.64437, 0.68752, 0.72891, 0.78554, 0.84578, 0.90595, 0.96706, 1.02865, 1.09042, 1.15083,
      1.21134, 1.26573, 1.31394, 1.35819, 1.39811, 1.43544, 1.46965, 1.50124, 1.52974, 1.55645, 1.58163, 1.60549,
      1.62821, 1.64923, 1.66945, 1.68897, 1.70725, 1.72503, 1.74179, 1.75763, 1.77321, 1.78802, 1.80214, 1.81564,
      1.82907, 1.84195, 1.85388, 1.8654, 1.87609, 1.88647, 1.89614, 1.90556, 1.91476, 1.92376, 1.93219, 1.94047,
      1.94861, 1.95662, 1.96416, 1.97161, 1.97897, 1.98626, 1.99378, 2.0014, 2.00881, 2.01602, 2.02303, 2.02987,
    ],
    10: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.642, 0.684, 0.726, 0.768, 0.81, 0.87, 0.92, 0.98, 1.04, 1.09, 1.12, 1.15, 1.18,
      1.21, 1.24, 1.25, 1.26, 1.27, 1.29, 1.3, 1.31, 1.33, 1.34, 1.35, 1.37, 1.38, 1.39, 1.4, 1.42, 1.43, 1.44, 1.46,
      1.47, 1.48, 1.5, 1.51, 1.52, 1.53, 1.55, 1.56, 1.57, 1.58, 1.58, 1.59, 1.6, 1.6, 1.61, 1.61, 1.62, 1.63, 1.63,
      1.63, 1.63807, 1.64356, 1.64891, 1.65412, 1.65919,
    ],
    11: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.63951, 0.67853, 0.71709, 0.75521, 0.79837, 0.84182, 0.8878, 0.93533, 0.98162,
      1.02291, 1.06048, 1.09524, 1.12785, 1.15877, 1.18548, 1.20885, 1.22954, 1.2493, 1.26713, 1.28338, 1.29936,
      1.31412, 1.32784, 1.34161, 1.35454, 1.36675, 1.37834, 1.39017, 1.40146, 1.41227, 1.42338, 1.43405, 1.44435,
      1.45496, 1.46521, 1.47515, 1.48481, 1.49479, 1.5045, 1.51396, 1.52321, 1.53176, 1.54016, 1.54842, 1.5561, 1.56369,
      1.57075, 1.57778, 1.58476, 1.59129, 1.5974, 1.60344, 1.60933, 1.61506, 1.62064, 1.62607,
    ],
    12: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.63672, 0.67374, 0.71043, 0.75027, 0.79099, 0.83396, 0.87854, 0.92255,
      0.96281, 1.00004, 1.03485, 1.0677, 1.09896, 1.12649, 1.15096, 1.17292, 1.19385, 1.21291, 1.23041, 1.2475, 1.26337,
      1.27819, 1.29292, 1.30679, 1.31992, 1.3324, 1.34501, 1.35706, 1.36861, 1.38036, 1.39167, 1.40258, 1.41372,
      1.42449, 1.43494, 1.4451, 1.45551, 1.46564, 1.47552, 1.48517, 1.49414, 1.50295, 1.51161, 1.51969, 1.52768,
      1.53515, 1.54257, 1.54992, 1.55683, 1.56333, 1.56975, 1.576, 1.58208, 1.58801, 1.5938,
    ],
    13: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.6336, 0.66884, 0.70548, 0.74355, 0.7836, 0.82531, 0.86706, 0.90625,
      0.94307, 0.97781, 1.0108, 1.0423, 1.07052, 1.09597, 1.11906, 1.14104, 1.16121, 1.17984, 1.19794, 1.21482, 1.23064,
      1.24625, 1.26099, 1.27497, 1.28826, 1.30159, 1.31434, 1.32657, 1.33891, 1.3508, 1.36227, 1.3739, 1.38516, 1.39608,
      1.40669, 1.4175, 1.42802, 1.43828, 1.4483, 1.45766, 1.46685, 1.47588, 1.48435, 1.4927, 1.50056, 1.50833, 1.51603,
      1.5233, 1.53016, 1.53693, 1.54353, 1.54996, 1.55622, 1.56232,
    ],
    14: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.63012, 0.66368, 0.69918, 0.73638, 0.7753, 0.81484, 0.85293,
      0.88926, 0.92386, 0.95689, 0.98854, 1.01736, 1.04366, 1.06776, 1.09068, 1.11186, 1.13152, 1.15054, 1.16835,
      1.18508, 1.20149, 1.21703, 1.23178, 1.24583, 1.25981, 1.2732, 1.28606, 1.29895, 1.31136, 1.32335, 1.33544,
      1.34714, 1.35849, 1.36952, 1.38069, 1.39157, 1.40218, 1.41254, 1.42227, 1.43182, 1.44118, 1.45001, 1.45871,
      1.46692, 1.47504, 1.48306, 1.49066, 1.49787, 1.50498, 1.5119, 1.51864, 1.52522, 1.53163,
    ],
    15: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.62457, 0.65757, 0.69203, 0.72823, 0.7656, 0.80256,
      0.83835, 0.87275, 0.90575, 0.93747, 0.96679, 0.99385, 1.01885, 1.04261, 1.0647, 1.08531, 1.10516, 1.12381,
      1.14138, 1.15853, 1.17478, 1.19025, 1.20499, 1.21958, 1.23356, 1.24699, 1.26038, 1.27329, 1.28576, 1.29825,
      1.31036, 1.32211, 1.33353, 1.34504, 1.35625, 1.36718, 1.37785, 1.38793, 1.3978, 1.40748, 1.41664, 1.42566,
      1.43421, 1.44264, 1.45097, 1.45889, 1.46642, 1.47384, 1.48106, 1.48811, 1.49498, 1.50168,
    ],
    16: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.61849, 0.65029, 0.68385, 0.71909, 0.75492, 0.79013,
      0.82426, 0.85717, 0.88889, 0.91862, 0.94635, 0.97216, 0.99668, 1.0196, 1.04106, 1.06167, 1.08108, 1.09942,
      1.11724, 1.13417, 1.15028, 1.16566, 1.18081, 1.19534, 1.2093, 1.22314, 1.2365, 1.24941, 1.26229, 1.27477, 1.28688,
      1.29866, 1.31048, 1.32199, 1.33322, 1.34419, 1.35458, 1.36475, 1.37472, 1.3842, 1.39351, 1.40238, 1.41111,
      1.41972, 1.42794, 1.43578, 1.44348, 1.451, 1.45833, 1.46548, 1.47246,
    ],
    17: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.61093, 0.64194, 0.6751, 0.70978, 0.74438,
      0.77819, 0.81096, 0.84263, 0.8727, 0.90101, 0.92755, 0.95275, 0.97641, 0.99865, 1.01995, 1.04007, 1.05911,
      1.07754, 1.09508, 1.1118, 1.12777, 1.14343, 1.15845, 1.1729, 1.18717, 1.20094, 1.21426, 1.22748, 1.24031, 1.25276,
      1.26487, 1.27697, 1.28876, 1.30026, 1.3115, 1.32218, 1.33263, 1.34288, 1.35265, 1.36224, 1.37139, 1.38041,
      1.38929, 1.39778, 1.40591, 1.41389, 1.42168, 1.42928, 1.43669, 1.44393,
    ],
    18: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60229, 0.63343, 0.66696, 0.70091, 0.73437,
      0.76695, 0.79852, 0.82886, 0.85768, 0.88487, 0.91068, 0.93502, 0.95797, 0.9799, 1.00067, 1.02035, 1.03935,
      1.05744, 1.07472, 1.09123, 1.10735, 1.12284, 1.13774, 1.1524, 1.16655, 1.18024, 1.19378, 1.20693, 1.21969, 1.2321,
      1.24446, 1.25651, 1.26826, 1.27974, 1.29069, 1.30141, 1.31191, 1.32195, 1.3318, 1.34123, 1.3505, 1.35963, 1.36839,
      1.37678, 1.38503, 1.39308, 1.40093, 1.40859, 1.41607,
    ],
    19: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60389, 0.62629, 0.65957, 0.69263,
      0.72498, 0.75641, 0.78698, 0.81624, 0.84402, 0.87037, 0.89533, 0.91892, 0.94142, 0.96278, 0.98305, 1.00256,
      1.02117, 1.03896, 1.05597, 1.07252, 1.08843, 1.10375, 1.11876, 1.13327, 1.1473, 1.16114, 1.17457, 1.18762, 1.2003,
      1.2129, 1.22519, 1.23717, 1.24888, 1.26008, 1.27104, 1.28177, 1.29206, 1.30216, 1.31184, 1.32136, 1.33073,
      1.33973, 1.34838, 1.35687, 1.36516, 1.37325, 1.38115, 1.38887,
    ],
    20: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60759, 0.6202, 0.65284, 0.68492,
      0.71617, 0.74691, 0.77656, 0.80486, 0.83171, 0.85722, 0.88141, 0.90443, 0.92632, 0.94714, 0.96712, 0.9862,
      1.00445, 1.02193, 1.03888, 1.05518, 1.07087, 1.08621, 1.10104, 1.11538, 1.1295, 1.14319, 1.1565, 1.16945, 1.18226,
      1.19476, 1.20696, 1.21887, 1.23031, 1.24149, 1.25244, 1.26297, 1.27329, 1.28321, 1.29296, 1.30255, 1.31178,
      1.32067, 1.32939, 1.33791, 1.34622, 1.35435, 1.36228,
    ],
    21: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.61486, 0.64665,
      0.67769, 0.70855, 0.73854, 0.7673, 0.79459, 0.8206, 0.84533, 0.86882, 0.89121, 0.91253, 0.93294, 0.95245, 0.97114,
      0.98904, 1.00635, 1.02301, 1.03906, 1.0547, 1.06982, 1.08446, 1.09881, 1.11275, 1.1263, 1.13948, 1.1525, 1.16519,
      1.17758, 1.18969, 1.20134, 1.21273, 1.22388, 1.23463, 1.24516, 1.25531, 1.26527, 1.27506, 1.28451, 1.29363,
      1.30257, 1.3113, 1.31983, 1.32816, 1.3363,
    ],
    22: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.61003,
      0.64084, 0.67178, 0.70206, 0.73125, 0.75892, 0.78539, 0.81062, 0.83454, 0.85737, 0.87916, 0.89995, 0.91987,
      0.93895, 0.95725, 0.97489, 0.99188, 1.00825, 1.02416, 1.03956, 1.05446, 1.06905, 1.08321, 1.09698, 1.11038,
      1.12357, 1.13645, 1.14901, 1.16129, 1.17314, 1.18473, 1.19607, 1.20701, 1.21774, 1.2281, 1.23827, 1.24825, 1.2579,
      1.26723, 1.27637, 1.28531, 1.29404, 1.30257, 1.31091,
    ],
    23: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60553,
      0.63652, 0.66705, 0.69661, 0.72463, 0.75151, 0.77719, 0.8015, 0.82475, 0.84695, 0.86811, 0.88839, 0.90784, 0.9265,
      0.94444, 0.96174, 0.97841, 0.99457, 1.01022, 1.02537, 1.04015, 1.05452, 1.06849, 1.08209, 1.09545, 1.10849,
      1.12122, 1.13366, 1.14569, 1.15745, 1.16896, 1.1801, 1.19101, 1.20157, 1.21192, 1.22208, 1.23192, 1.24145,
      1.25079, 1.25991, 1.26883, 1.27755, 1.28608,
    ],
    24: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001,
      0.60267, 0.63341, 0.6633, 0.69163, 0.71889, 0.74498, 0.76965, 0.79327, 0.81586, 0.83735, 0.85796, 0.87775,
      0.89674, 0.91496, 0.93254, 0.94948, 0.96588, 0.98175, 0.99713, 1.0121, 1.02665, 1.04081, 1.05459, 1.0681, 1.08129,
      1.09416, 1.10675, 1.11895, 1.13087, 1.14254, 1.15386, 1.16494, 1.17568, 1.18621, 1.19653, 1.20655, 1.21627,
      1.22579, 1.2351, 1.2442, 1.25309, 1.26179,
    ],
    25: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001,
      0.60106, 0.63125, 0.65986, 0.68745, 0.71392, 0.73891, 0.76288, 0.78582, 0.80761, 0.82853, 0.84862, 0.86792,
      0.88641, 0.90423, 0.92144, 0.93804, 0.95412, 0.96971, 0.98485, 0.99957, 1.0139, 1.02784, 1.04149, 1.05481,
      1.06782, 1.08053, 1.09289, 1.10497, 1.11679, 1.12827, 1.1395, 1.15041, 1.16111, 1.17159, 1.18177, 1.19167,
      1.20136, 1.21084, 1.22011, 1.22917, 1.23803,
    ],
    26: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6,
      0.60001, 0.60038, 0.62923, 0.65714, 0.68395, 0.70923, 0.73351, 0.75679, 0.77884, 0.80005, 0.82043, 0.84001,
      0.85873, 0.87679, 0.89423, 0.91102, 0.92729, 0.94307, 0.95836, 0.97324, 0.98772, 1.00182, 1.01558, 1.02903,
      1.04216, 1.055, 1.0675, 1.07971, 1.09166, 1.1033, 1.11468, 1.12575, 1.1366, 1.14722, 1.15757, 1.16763, 1.17748,
      1.18712, 1.19654, 1.20576, 1.21479,
    ],
    27: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6,
      0.60001, 0.60001, 0.62789, 0.65501, 0.68056, 0.70513, 0.7287, 0.75101, 0.77247, 0.79311, 0.81296, 0.83189,
      0.85016, 0.86782, 0.88478, 0.90123, 0.91718, 0.93261, 0.94763, 0.96225, 0.97649, 0.99036, 1.00392, 1.01716,
      1.0301, 1.04273, 1.05508, 1.06716, 1.07893, 1.09045, 1.10167, 1.11266, 1.12342, 1.13391, 1.14413, 1.15414,
      1.16392, 1.1735, 1.18286, 1.19203,
    ],
    28: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.6, 0.60001, 0.60001, 0.62705, 0.65284, 0.67767, 0.70152, 0.72406, 0.74576, 0.76663, 0.78672, 0.80585, 0.82432,
      0.84217, 0.8593, 0.8759, 0.89201, 0.90757, 0.92271, 0.93746, 0.95182, 0.9658, 0.97945, 0.99279, 1.00583, 1.01859,
      1.03105, 1.04324, 1.05514, 1.06678, 1.07815, 1.08927, 1.10016, 1.11078, 1.12115, 1.1313, 1.14123, 1.15094,
      1.16045, 1.16976,
    ],
    29: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.6, 0.60001, 0.60002, 0.62603, 0.6511, 0.67521, 0.69795, 0.71986, 0.74096, 0.76127, 0.78057, 0.79923,
      0.81726, 0.83453, 0.85128, 0.86753, 0.8832, 0.89846, 0.91332, 0.9278, 0.94186, 0.9556, 0.96903, 0.98216, 0.99503,
      1.0076, 1.01989, 1.03191, 1.04367, 1.05517, 1.06641, 1.07741, 1.08817, 1.09868, 1.10896, 1.11902, 1.12887,
      1.13851, 1.14795,
    ],
    30: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.6, 0.60001, 0.60009, 0.62538, 0.64971, 0.67264, 0.69475, 0.71605, 0.73657, 0.75603, 0.77485, 0.79305,
      0.81045, 0.82733, 0.84371, 0.85949, 0.87485, 0.88981, 0.90439, 0.91853, 0.93235, 0.94586, 0.95907, 0.97203,
      0.9847, 0.99709, 1.00923, 1.02109, 1.03271, 1.04406, 1.05518, 1.06606, 1.07669, 1.0871, 1.09729, 1.10726, 1.11703,
      1.12659,
    ],
    31: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.6, 0.60001, 0.60046, 0.62501, 0.6481, 0.67039, 0.69188, 0.71258, 0.73219, 0.75117, 0.76951,
      0.78702, 0.80402, 0.82053, 0.83639, 0.85185, 0.8669, 0.88158, 0.89578, 0.90967, 0.92325, 0.93653, 0.94959,
      0.96235, 0.97482, 0.98706, 0.99902, 1.01075, 1.02222, 1.03343, 1.04442, 1.05518, 1.06571, 1.07601, 1.0861,
      1.09599, 1.10567,
    ],
    32: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60105, 0.62429, 0.64675, 0.66841, 0.68928, 0.70903, 0.72813, 0.74662, 0.76424,
      0.78134, 0.79796, 0.8139, 0.82943, 0.84458, 0.85933, 0.8736, 0.88755, 0.90119, 0.91453, 0.92767, 0.94051, 0.95306,
      0.9654, 0.97745, 0.98928, 1.00085, 1.01216, 1.02325, 1.03413, 1.04476, 1.05518, 1.06538, 1.07538, 1.08517,
    ],
    33: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60119, 0.62379, 0.6456, 0.66663, 0.6865, 0.70573, 0.72434, 0.74205,
      0.75926, 0.77597, 0.79198, 0.80759, 0.82281, 0.83764, 0.85195, 0.86595, 0.87965, 0.89305, 0.90626, 0.91918,
      0.9318, 0.94422, 0.95636, 0.96829, 0.97994, 0.99134, 1.00254, 1.01352, 1.02426, 1.03478, 1.04508, 1.05518,
      1.06508,
    ],
    34: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60149, 0.62344, 0.64462, 0.66459, 0.68394, 0.70266, 0.72046,
      0.73775, 0.75455, 0.77062, 0.78629, 0.80157, 0.81647, 0.83083, 0.84488, 0.85862, 0.87206, 0.88535, 0.89833,
      0.91102, 0.92352, 0.93573, 0.94775, 0.95949, 0.97097, 0.98225, 0.99333, 1.00417, 1.01479, 1.02519, 1.03539,
      1.04538,
    ],
    35: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.6019, 0.6232, 0.64328, 0.66273, 0.68156, 0.69942, 0.71679,
      0.73367, 0.74979, 0.76552, 0.78086, 0.79582, 0.81021, 0.8243, 0.83808, 0.85156, 0.86491, 0.87795, 0.89069,
      0.90327, 0.91555, 0.92765, 0.93947, 0.95102, 0.96239, 0.97357, 0.9845, 0.99521, 1.0057, 1.01599, 1.02608,
    ],
    36: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60237, 0.62253, 0.64207, 0.66099, 0.67893, 0.69636,
      0.71331, 0.72948, 0.74526, 0.76064, 0.77565, 0.79008, 0.80419, 0.81801, 0.83153, 0.84493, 0.85802, 0.87082,
      0.88346, 0.89581, 0.90798, 0.91987, 0.9315, 0.94294, 0.95421, 0.96522, 0.97602, 0.9866, 0.99697, 1.00714,
    ],
    37: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60233, 0.62195, 0.64096, 0.65895, 0.67644, 0.69346,
      0.70966, 0.72548, 0.74091, 0.75596, 0.77041, 0.78455, 0.79839, 0.81194, 0.82539, 0.83853, 0.85137, 0.86408,
      0.87648, 0.88873, 0.90069, 0.91237, 0.92389, 0.93524, 0.94633, 0.95721, 0.96787, 0.97832, 0.98858,
    ],
    38: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60235, 0.62143, 0.63947, 0.65702, 0.67408,
      0.69032, 0.70617, 0.72164, 0.73673, 0.7512, 0.76536, 0.77922, 0.7928, 0.80628, 0.81946, 0.83235, 0.8451, 0.85756,
      0.86987, 0.88189, 0.89363, 0.90522, 0.91664, 0.92781, 0.93876, 0.9495, 0.96003, 0.97036,
    ],
    39: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60239, 0.62047, 0.63807, 0.65518, 0.67144,
      0.68732, 0.70282, 0.71794, 0.73242, 0.74659, 0.76047, 0.77407, 0.78759, 0.80081, 0.81372, 0.82653, 0.83904,
      0.85141, 0.86348, 0.87527, 0.88693, 0.89842, 0.90966, 0.92068, 0.93149, 0.94209, 0.95249,
    ],
    40: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60194, 0.61957, 0.63673, 0.65301,
      0.66891, 0.68443, 0.69958, 0.71406, 0.72825, 0.74214, 0.75575, 0.7693, 0.78255, 0.7955, 0.80835, 0.82089, 0.83332,
      0.84545, 0.85728, 0.86899, 0.88055, 0.89186, 0.90294, 0.91382, 0.92449, 0.93496,
    ],
    41: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.60152, 0.61871, 0.635, 0.65092,
      0.66646, 0.68163, 0.69612, 0.71031, 0.7242, 0.73782, 0.7514, 0.76467, 0.77765, 0.79054, 0.80312, 0.8156, 0.82777,
      0.83965, 0.85141, 0.86304, 0.8744, 0.88554, 0.89648, 0.90721, 0.91774,
    ],
    42: [
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.6, 0.60001, 0.6011, 0.61741, 0.63334,
      0.64889, 0.66408, 0.67856, 0.69275, 0.70665, 0.72027, 0.73388, 0.74717, 0.76016, 0.77309, 0.78571, 0.79823,
      0.81044, 0.82236, 0.83417, 0.84585, 0.85727, 0.86847, 0.87947, 0.89026, 0.90085,
    ],
  },
};
